import axios from "axios";
import { Config } from "../../../core/config/config";
import { processLoadOptions } from "../../../core/helper/datasource-query-helper";

const GATEWAY_URL = `${Config.VITE_APP_GATEWAY_URL}/api/product/product-brand`;

export const productBrandService = {
    listProductBrand: async function (loadOptions:any) {
        const params = processLoadOptions(loadOptions)
        return axios.get(`${GATEWAY_URL}/list-product-brands`,{
            params
        }).then((response) => {
            return response.data;
        });
    },
    lookupProductBrand: async function (loadOptions:any) {
        const params = processLoadOptions(loadOptions)
        return axios.get(`${GATEWAY_URL}/lookup-product-brands`,{
            params
        }).then((response) => {
            return response.data;
        });
    },
    getProductBrand: async function (id: any) {
        return axios.get(`${GATEWAY_URL}/get-product-brand`, {
            params: { id }
        })
        .then((response) => {
            return response.data;
        });
    }
}
